import { ValidationRule } from '../validation.rule';
import { ValidationTypes } from '../validationtypes';

export class RequiredValidationRule extends ValidationRule {
  constructor(key: string) {
    if (!key) {
      key = ValidationTypes.required;
    }

    super(key);
  }

  isValid(value: any): boolean {
    if (typeof value === 'string') {
      value = value.trim();
    }

    return !(value === null || value === undefined || value === '' || value == '00000000-0000-0000-0000-000000000000');
  }
}
